module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_Bettwil-8161d0b9f3eb072bbfb86ef49ed032a3.svg";